module.exports = __webpack_public_path__ + "static/carousel-4-4d45ea54cb935415eff9be7463b9cb92.png";